import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
export var LayoutContext = /*#__PURE__*/React.createContext({
  siderHook: {
    addSider: function addSider() {
      return null;
    },
    removeSider: function removeSider() {
      return null;
    }
  }
});

function generator(_ref) {
  var suffixCls = _ref.suffixCls,
      tagName = _ref.tagName,
      displayName = _ref.displayName;
  return function (BasicComponent) {
    var Adapter = function Adapter(props) {
      var _React$useContext = React.useContext(ConfigContext),
          getPrefixCls = _React$useContext.getPrefixCls,
          pkgPrefixCls = _React$useContext.prefixCls,
          userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


      var _getCompProps = getCompProps('Layout', userDefaultProps, props),
          customPrefixcls = _getCompProps.prefixCls; // className前缀


      var prefixCls = getPrefixCls(pkgPrefixCls, suffixCls, customPrefixcls);
      return /*#__PURE__*/React.createElement(BasicComponent, _extends({
        prefixCls: prefixCls,
        tagName: tagName
      }, props));
    };

    Adapter.displayName = displayName;
    return Adapter;
  };
}

var Basic = function Basic(props) {
  var _React$useContext2 = React.useContext(ConfigContext),
      userDefaultProps = _React$useContext2.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _a = getCompProps('Layout', userDefaultProps, props),
      className = _a.className,
      children = _a.children,
      prefixCls = _a.prefixCls,
      tagName = _a.tagName,
      others = __rest(_a, ["className", "children", "prefixCls", "tagName"]);

  var classString = classNames(prefixCls, className);
  return /*#__PURE__*/React.createElement(tagName, _extends({
    className: classString
  }, others), children);
};

var BasicLayout = function BasicLayout(props) {
  var _React$useContext3 = React.useContext(ConfigContext),
      userDefaultProps = _React$useContext3.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _a = getCompProps('Layout', userDefaultProps, props),
      style = _a.style,
      className = _a.className,
      children = _a.children,
      prefixCls = _a.prefixCls,
      hasSider = _a.hasSider,
      Tag = _a.tagName,
      others = __rest(_a, ["style", "className", "children", "prefixCls", "hasSider", "tagName"]);

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      siders = _React$useState2[0],
      setSiders = _React$useState2[1];

  var classString = classNames(prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : siders.length > 0), className);

  var styleString = _extends({}, style);

  return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
    value: {
      siderHook: {
        addSider: function addSider(id) {
          setSiders(function (prev) {
            var _context;

            return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(prev), [id]);
          });
        },
        removeSider: function removeSider(id) {
          setSiders(function (prev) {
            return _filterInstanceProperty(prev).call(prev, function (currentId) {
              return currentId !== id;
            });
          });
        }
      }
    }
  }, /*#__PURE__*/React.createElement(Tag, _extends({
    className: classString
  }, others, {
    style: styleString
  }), children));
};

var Layout = generator({
  suffixCls: 'layout',
  tagName: 'section',
  displayName: 'Layout'
})(BasicLayout);
var Header = generator({
  suffixCls: 'layout-header',
  tagName: 'header',
  displayName: 'Header'
})(Basic);
var Footer = generator({
  suffixCls: 'layout-footer',
  tagName: 'footer',
  displayName: 'Footer'
})(Basic);
var Content = generator({
  suffixCls: 'layout-content',
  tagName: 'main',
  displayName: 'Content'
})(Basic);
export { Header, Footer, Content };
export default Layout;